import React, {FC} from 'react';
import {View} from 'react-native';
import {includes} from 'lodash';

import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {DownlineProfile, UserProfileModal} from '/constant/TestIDs';
import {PROFILE_FIELD_COACH} from '/enum/profileField.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {getDateUtilDefaultInstance} from '/util/date.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './ProfileActivationDateSection.style';

interface ProfileActivationDateSectionProps {
  tt: (key: string, value: string) => string;
  fields: string[];
  coachName: string;
  dateJoined: string;
  onCoachProfilePress: () => void;
}

export const ProfileActivationDateSection: FC<
  ProfileActivationDateSectionProps
> = ({
  tt = withTranslation.ttDefaultProp,
  fields = [PROFILE_FIELD_COACH],
  coachName = '',
  dateJoined = '',
  onCoachProfilePress = () => {},
}: ProfileActivationDateSectionProps) => {
  return (
    <View>
      {!!dateJoined && (
        <View style={styles.rowContainer}>
          <Text
            variant="heading"
            emphasis="dull"
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={styles.coach}>
            {tt('dateJoined', 'Date Joined')}
          </Text>
          <Text
            variant="body"
            allowFontScaling
            maxFontSizeMultiplier={2}
            {...testProperties(UserProfileModal.activationDate)}>
            {getDateUtilDefaultInstance().formatDate(
              dateJoined,
              'MMMM d, yyyy',
            )}
          </Text>
        </View>
      )}
      {includes(fields, PROFILE_FIELD_COACH) && (
        <View style={styles.rowContainer}>
          <Text
            variant="heading"
            emphasis="dull"
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={styles.coach}>
            {tt('coach', 'Coach')}
          </Text>
          <TouchableOpacity
            onPress={onCoachProfilePress}
            {...testProperties(null, true)}>
            <Text
              variant="subheading"
              allowFontScaling
              maxFontSizeMultiplier={2}
              useCompetency={true}
              {...testProperties(DownlineProfile.profileCoachValue)}>
              {coachName
                ? tt('coachName', coachName)
                : tt('notApplicable', 'N/A')}
            </Text>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
};
